import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_group = _resolveComponent("v-list-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.legalForm === 'SCI')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_radio_group, {
            modelValue: _ctx.companyUser.investment.partnerType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyUser.investment.partnerType) = $event)),
            inline: "",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio, {
                value: "landTenureAssociate",
                label: "Régime Foncier (IR)",
                color: "primary"
              }),
              _createVNode(_component_v_radio, {
                value: "professionalRegimeAssociate",
                label: "Régime Professionel (IS)",
                disabled: _ctx.user.type === 'NATURAL_PERSON',
                color: "primary"
              }, null, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_tabs_window, {
            modelValue: _ctx.companyUser.investment.partnerType,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.companyUser.investment.partnerType) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "landTenureAssociate" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                          _createElementVNode("h4", null, "Identification", -1)
                        ])),
                        _: 1
                      }),
                      (_ctx.type === 'NATURAL_PERSON')
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": "",
                            class: "py-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: _ctx.companyUser.investment.taxNumber,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyUser.investment.taxNumber) = $event)),
                                    label: 
                                            _ctx.selectedCompany.taxSystemType === 'IR'
                                                ? 'Numéro fiscal'
                                                : 'Numéro fiscal (facultatif pour une SCI à l\'IS)'
                                        ,
                                    outlined: "",
                                    "hide-details": "",
                                    density: "compact"
                                  }, null, 8, ["modelValue", "label"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_ctx.type === 'LEGAL_PERSON')
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 1,
                              "no-gutters": "",
                              class: "py-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.companyUser.investment.siren,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyUser.investment.siren) = $event)),
                                      label: "SIREN",
                                      outlined: "",
                                      "hide-details": "",
                                      rules: [
                                            (v) => !!v || _ctx.$t('settings.itemRequired'),
                                            (v) => (v || '').length <= 9 || _ctx.$t('settings.tooLong'),
                                            (v) => (v || '').length >= 9 || _ctx.$t('settings.tooShort'),
                                        ],
                                      density: "compact"
                                    }, null, 8, ["modelValue", "rules"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "professionalRegimeAssociate" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                          _createElementVNode("h4", null, "Identification", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "py-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "pr-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.companyUser.investment.siren,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyUser.investment.siren) = $event)),
                                label: "SIREN",
                                outlined: "",
                                "hide-details": "",
                                rules: [
                                        (v) => !!v || _ctx.$t('settings.itemRequired'),
                                        (v) => (v || '').length <= 9 || _ctx.$t('settings.tooLong'),
                                        (v) => (v || '').length >= 9 || _ctx.$t('settings.tooShort'),
                                    ],
                                density: "compact"
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "pl-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select_filled, {
                                class: "pr-1",
                                "hide-details": "",
                                outlined: "",
                                modelValue: _ctx.companyUser.investment.taxCategory,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyUser.investment.taxCategory) = $event)),
                                items: ['BIC', 'IS', 'BA'],
                                label: "Catégorie fiscale",
                                density: "compact"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "pl-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.companyUser.investment.holding,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyUser.investment.holding) = $event)),
                                label: "Holding",
                                dense: "",
                                "hide-details": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-1 pb-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => _cache[36] || (_cache[36] = [
                          _createElementVNode("h4", null, "Cadres (facultatif)", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "py-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.companyUser.investment.director.show,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyUser.investment.director.show) = $event)),
                                label: "Administrateur",
                                dense: "",
                                "hide-details": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.companyUser.investment.accountant.show,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.companyUser.investment.accountant.show) = $event)),
                                label: "Comptable",
                                dense: "",
                                "hide-details": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.companyUser.investment.manager.show,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.companyUser.investment.manager.show) = $event)),
                                label: "Gérant",
                                dense: "",
                                "hide-details": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (_ctx.companyUser.investment[role.value].show)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": "",
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(role.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleFields, (field) => {
                                    return (_openBlock(), _createBlock(_component_v_col, {
                                      cols: field.value === 'address' ? 8 : 4,
                                      class: _normalizeClass(field.class),
                                      key: field.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          modelValue: _ctx.companyUser.investment[role.value][field.value],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.companyUser.investment[role.value][field.value]) = $event),
                                          label: field.name,
                                          outlined: "",
                                          "hide-details": "",
                                          density: "compact"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                                      ]),
                                      _: 2
                                    }, 1032, ["cols", "class"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.companyUser.investment[role.value].show)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_divider),
          (_ctx.companyUser.investment.partnerType !== 'shareTransfer')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_v_divider),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "pt-2 pb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                        _createElementVNode("h4", null, "Parts", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "pt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_data_table, {
                          headers: _ctx.companySharesHeaders,
                          items: _ctx.companyUser.investment.shares,
                          "fixed-header": "",
                          "hide-default-footer": "",
                          "no-data-text": 'Pas d\'historique',
                          "sort-by": _ctx.sortByDateDesc,
                          style: {"border":"1px #ededed solid"},
                          density: "compact",
                          class: "table elevation-0"
                        }, {
                          item: _withCtx((props) => [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.formatDate(props.item.date)), 1),
                              _createElementVNode("td", _hoisted_3, _toDisplayString(props.item.quantity), 1),
                              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.formatAmount(props.item.amount)), 1),
                              _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.formatPercentage(props.item.percentage)), 1),
                              _createElementVNode("td", _hoisted_6, [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex justify-center align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$oss-edit",
                                          elevation: "0",
                                          rounded: "",
                                          dense: "",
                                          onClick: _withModifiers(($event: any) => (_ctx.editShare(props.item)), ["stop"]),
                                          size: "x-small"
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("td", _hoisted_7, [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex justify-center align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_trash, {
                                          onClick: _withModifiers(($event: any) => (_ctx.deleteItem(props.item, 'shares')), ["stop"]),
                                          size: "x-small"
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["headers", "items", "sort-by"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "1",
                      class: "pt-5 pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tooltip, { location: "start" }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_add_icon, _mergeProps({ size: "x-small" }, props, {
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openSharesDialog()))
                            }), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _cache[38] || (_cache[38] = _createElementVNode("span", null, "Déclarer un changement", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "pt-2 pb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[39] || (_cache[39] = [
                        _createElementVNode("h4", null, "Titres", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "pt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_data_table, {
                          headers: _ctx.companyTitlesHeaders,
                          items: _ctx.companyUser.investment.titles,
                          "fixed-header": "",
                          "hide-default-footer": "",
                          "no-data-text": 'Pas d\'historique',
                          "sort-by": _ctx.sortByDateDesc,
                          style: {"border":"1px #ededed solid"},
                          density: "compact",
                          class: "table elevation-0"
                        }, {
                          item: _withCtx((props) => [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.formatDate(props.item.date)), 1),
                              _createElementVNode("td", _hoisted_9, _toDisplayString(props.item.bareOwnershipShares), 1),
                              _createElementVNode("td", _hoisted_10, _toDisplayString(props.item.usufructShares), 1),
                              _createElementVNode("td", _hoisted_11, [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex justify-center align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$oss-edit",
                                          elevation: "0",
                                          rounded: "",
                                          dense: "",
                                          onClick: _withModifiers(($event: any) => (_ctx.editTitle(props.item)), ["stop"]),
                                          size: "x-small"
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("td", _hoisted_12, [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex justify-center align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_trash, {
                                          onClick: _withModifiers(($event: any) => (_ctx.deleteItem(props.item, 'titles')), ["stop"]),
                                          size: "x-small"
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["headers", "items", "sort-by"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "1",
                      class: "pt-5 pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tooltip, { location: "start" }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_add_icon, _mergeProps({
                              size: "x-small",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openTitlesDialog()))
                            }, props), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _cache[40] || (_cache[40] = _createElementVNode("span", null, "Déclarer un changement", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex align-center py-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "pr-3 d-flex justify-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "x-small" }, {
                              default: _withCtx(() => _cache[41] || (_cache[41] = [
                                _createTextVNode("$fa-circle")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "pl-3"
                        }, {
                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                            _createTextVNode(" Détenteur de l'usufruit ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.companyUser.investment.usufructHolder,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.companyUser.investment.usufructHolder) = $event)),
                              outlined: "",
                              "hide-details": "",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "pt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[43] || (_cache[43] = [
                        _createElementVNode("h4", null, "Jouissance de l'immeuble", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "py-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "11" }, {
                          default: _withCtx(() => _cache[44] || (_cache[44] = [
                            _createTextVNode(" Jouissance gratuite de tout ou partie d'un immeuble détenu par la société immobilière ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "pr-1 justify-end d-flex"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.companyUser.investment.freeUse,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.companyUser.investment.freeUse) = $event)),
                              dense: "",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "py-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => _cache[45] || (_cache[45] = [
                            _createTextVNode(" Immeuble(s) dont l'associé à la jouissance gratuite ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "pr-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select_filled, {
                              "hide-details": "",
                              outlined: "",
                              multiple: "",
                              modelValue: _ctx.companyUser.investment.freeUseBuildings,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.companyUser.investment.freeUseBuildings) = $event)),
                              items: _ctx.companyData.buildingsProperties,
                              "item-value": "name",
                              label: "Immeubles",
                              density: "compact",
                              "item-title": (item) => item.name
                            }, null, 8, ["modelValue", "items", "item-title"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.sharesDialog)
            ? (_openBlock(), _createBlock(_component_oss_dialog, {
                key: 1,
                modelValue: _ctx.sharesDialog,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.sharesDialog) = $event)),
                title: "Ajouter part(s)",
                onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.sharesDialog = false)),
                onValid: _cache[21] || (_cache[21] = ($event: any) => (_ctx.upsertSharesTitles())),
                "valid-disabled": !_ctx.isValidShares,
                width: "800px"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex justify-center align-center pt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_date_picker_filled, {
                              label: "Date",
                              modelValue: _ctx.newShare.date,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newShare.date) = $event)),
                              outlined: "",
                              textFieldClass: "oss- pb-5",
                              disabled: _ctx.isEditingShare,
                              "hide-details": ""
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field_filled, {
                              outlined: "",
                              label: "Parts détenues",
                              modelValue: _ctx.newShare.quantity,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newShare.quantity) = $event)),
                              class: "pl-2 pt-1",
                              dense: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field_filled, {
                              outlined: "",
                              label: "Montant nomial",
                              modelValue: _ctx.newShare.amount,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newShare.amount) = $event)),
                              class: "pl-2 pt-1",
                              dense: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field_filled, {
                              outlined: "",
                              label: "Détenue en %",
                              modelValue: _ctx.newShare.percentage,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newShare.percentage) = $event)),
                              class: "pl-2 pt-1",
                              dense: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "valid-disabled"]))
            : _createCommentVNode("", true),
          (_ctx.titlesDialog)
            ? (_openBlock(), _createBlock(_component_oss_dialog, {
                key: 2,
                modelValue: _ctx.titlesDialog,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.titlesDialog) = $event)),
                title: "Ajouter titre(s)",
                onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.titlesDialog = false)),
                onValid: _cache[29] || (_cache[29] = ($event: any) => (_ctx.upsertSharesTitles())),
                "valid-disabled": !_ctx.isValidTitles,
                width: "800px"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex justify-center align-center pt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_date_picker_filled, {
                              label: "Date",
                              modelValue: _ctx.newTitle.date,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newTitle.date) = $event)),
                              outlined: "",
                              textFieldClass: "oss- pb-5",
                              "hide-details": "",
                              disabled: _ctx.isEditingTitle
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field_filled, {
                              outlined: "",
                              label: "Titres en nue-propriété",
                              modelValue: _ctx.newTitle.bareOwnershipShares,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newTitle.bareOwnershipShares) = $event)),
                              class: "pl-2 pt-1",
                              dense: "",
                              onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.newTitle.usufructShares = 0))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field_filled, {
                              outlined: "",
                              label: "Titres en usufruit",
                              modelValue: _ctx.newTitle.usufructShares,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.newTitle.usufructShares) = $event)),
                              class: "pl-2 pt-1",
                              dense: "",
                              onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.newTitle.bareOwnershipShares = 0))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "valid-disabled"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pb-1"
              }, {
                default: _withCtx(() => _cache[46] || (_cache[46] = [
                  _createElementVNode("span", { class: "title ml-2" }, "Investissement", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.companyUser.investment.capitalShare,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.companyUser.investment.capitalShare) = $event)),
                    modelModifiers: { number: true },
                    outlined: "",
                    label: "Nombre de parts",
                    "hide-details": "",
                    density: "compact",
                    onChange: _ctx.autoFillAssociateSharePercentage
                  }, null, 8, ["modelValue", "onChange"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.associateSharesWarningMessage), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.companyUser.investment.amount,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.companyUser.investment.amount) = $event)),
                    modelModifiers: { number: true },
                    outlined: "",
                    label: "Pourcentage",
                    "hide-details": "",
                    density: "compact",
                    onChange: _ctx.autoFillAssociateSharesNumber
                  }, null, 8, ["modelValue", "onChange"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.associateSharePercentageWarningMessage), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])),
    (_ctx.companyUser.investment.partnerType !== 'shareTransfer' && _ctx.legalForm === 'SCI')
      ? (_openBlock(), _createBlock(_component_v_list_group, { key: 2 }, {
          activator: _withCtx(() => [
            _createVNode(_component_v_list_item_title, { class: "text-left text-wrap" }, {
              default: _withCtx(() => _cache[47] || (_cache[47] = [
                _createElementVNode("b", null, "Intégration dans la SCI (facultatif)", -1)
              ])),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "py-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  class: "pr-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_date_picker_filled, {
                      label: "Date d'entrée",
                      modelValue: _ctx.companyUser.investment.entryDate,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.companyUser.investment.entryDate) = $event)),
                      outlined: "",
                      textFieldReadOnly: false,
                      "text-field-readonly": false,
                      "hide-details": "auto"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  class: "pr-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_date_picker_filled, {
                      modelValue: _ctx.companyUser.investment.exitDate,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.companyUser.investment.exitDate) = $event)),
                      textFieldReadOnly: false,
                      "text-field-readonly": false,
                      "hide-details": "auto"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['beginningYear', 'endYear'], (addressType) => {
                  return _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pb-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Adresse au " + _toDisplayString(addressType === "beginningYear" ? "1 janvier" : "31 décembre") + " de l'année déclarée " + _toDisplayString(addressType === "endYear"
                                    ? " (en cas de changement d'adresse au cours de l'année)"
                                    : ""), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "py-2 pr-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.companyUser.investment[addressType + 'Address'].address,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.companyUser.investment[addressType + 'Address'].address) = $event),
                            label: "Adresse",
                            outlined: "",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          cols: 4,
                          class: _normalizeClass(field.class),
                          key: field.value
                        }, {
                          default: _withCtx(() => [
                            (field.value !== 'postalCode')
                              ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                  key: 0,
                                  modelValue: 
                                    _ctx.companyUser.investment[addressType + 'Address'][field.value]
                                ,
                                  "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.companyUser.investment[addressType + 'Address'][field.value]
                                ) = $event),
                                  label: field.name,
                                  outlined: "",
                                  "hide-details": "",
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                              : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                  key: 1,
                                  modelValue: 
                                    _ctx.companyUser.investment[addressType + 'Address'][field.value]
                                ,
                                  "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.companyUser.investment[addressType + 'Address'][field.value]
                                ) = $event),
                                  label: "Code Postal",
                                  outlined: "",
                                  "hide-details": "",
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}